import React from 'react';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './ContentByUser.scss';
const ContentByUser = ({ contentUrl , biData , contentTitle  })=>{
    return /*#__PURE__*/ React.createElement(BiLink, {
        className: s['root'],
        href: contentUrl,
        biData: biData
    }, contentTitle);
};
ContentByUser.displayName = 'ContentByUser';
export default ContentByUser;
